/**
 * Meus pagamentos (spec 011, secao 6): o que o trader pagou no sistema novo, em ordem: a compra do plano e as
 * mensalidades. Venda do sistema antigo nao entra aqui (Vitor, 15/09); ela fica com a equipe, no painel.
 */
import { Aviso, Carregando, Cartao, formatarDataHora, formatarDia, formatarReais, Paginacao, paginar, Pilha, Selo } from "@mtc/ui";
import { useQuery } from "@tanstack/react-query";
import { useApi } from "../acoes";
import { useDentroDeAssunto } from "../assunto";
import { marca } from "../config";
import { usePagina } from "../pagina";

type Pagamento = { id: string; tipo: "COMPRA" | "RENOVACAO" | "MENSALIDADE" | "PEDIDO"; titulo: string; detalhe: string; valor_centavos: number; pago_em: string; meio: string | null; comprovante: string | null; pedido: string | null };

const TOM = { COMPRA: "acento", RENOVACAO: "info", MENSALIDADE: "neutro", PEDIDO: "neutro" } as const;
// PEDIDO: a mensalidade antecipada paga no avanco, antes de a conta nova ser liberada (spec 038).
const ROTULO = { COMPRA: "Compra", RENOVACAO: "Renovação", MENSALIDADE: "Mensalidade", PEDIDO: "Avanço de etapa" } as const;

export function PaginaPagamentos() {
  const pag = usePagina();
  const { ler } = useApi();
  const dentroDeAssunto = useDentroDeAssunto();
  const q = useQuery({ queryKey: ["pagamentos"], queryFn: () => ler<{ itens: Pagamento[]; total_centavos: number; sistema_antigo_ate: string | null }>("/v1/me/pagamentos") });
  // Quem veio do sistema antigo pagou la antes da mudanca: esses pagamentos ficam com a equipe (Vitor, 15/09).
  const whatsapp = marca().whatsapp;
  const antigos = q.data?.sistema_antigo_ate ? (
    <Cartao>
      <p className="mtc-texto-2" style={{ margin: 0 }}>
        Pagamentos feitos antes de {formatarDia(q.data.sistema_antigo_ate)} ficam com a equipe. Precisa de um comprovante? {whatsapp ? <a className="mtc-link" href={whatsapp} target="_blank" rel="noreferrer">Fale com o suporte</a> : "Fale com o suporte"}.
      </p>
    </Cartao>
  ) : null;
  return (
    <Pilha espaco={6}>
      {dentroDeAssunto ? (
        q.data && q.data.itens.length > 0 && <span className="mtc-texto-2" style={{ fontSize: "var(--t-sm)" }}>{q.data.itens.length} pagamento{q.data.itens.length > 1 ? "s" : ""}, somando {formatarReais(q.data.total_centavos)}.</span>
      ) : (
        <header style={{ display: "grid", gap: "var(--e-2)" }}>
          <h1 className="mtc-titulo mtc-cabecalho__titulo">Meus pagamentos</h1>
          {q.data && q.data.itens.length > 0 && <p className="mtc-cabecalho__descricao">{q.data.itens.length} pagamento{q.data.itens.length > 1 ? "s" : ""}, somando {formatarReais(q.data.total_centavos)}.</p>}
        </header>
      )}
      {q.isLoading ? (
        <Carregando compacto texto="Buscando seus pagamentos" />
      ) : q.isError ? (
        <Aviso tipo="erro">Não consegui buscar agora. Tente de novo em instantes.</Aviso>
      ) : !q.data?.itens.length ? (
        antigos ?? <Cartao><p className="mtc-texto-2" style={{ margin: 0 }}>Nenhum pagamento por aqui ainda. Compras e mensalidades aparecem nesta lista.</p></Cartao>
      ) : (
        [...paginar(q.data.itens, pag.pagina).map((p) => (
          <Cartao key={p.id}>
            <div className="mtc-linha mtc-linha--entre" style={{ gap: "var(--e-3)", alignItems: "flex-start" }}>
              <div style={{ display: "grid", gap: 2, minWidth: 0 }}>
                <strong>{p.titulo}</strong>
                <span className="mtc-texto-2" style={{ fontSize: "var(--t-sm)" }}>{p.detalhe} · {formatarDataHora(p.pago_em)}{p.meio ? ` · ${p.meio}` : ""}</span>
                {p.comprovante && <span className="mtc-texto-2 mtc-mono" style={{ fontSize: "var(--t-xs)", overflowWrap: "anywhere" }}>{p.comprovante}</span>}
              </div>
              <div style={{ display: "grid", gap: 4, justifyItems: "end" }}>
                <span className="mtc-mono">{formatarReais(p.valor_centavos)}</span>
                <Selo tom={TOM[p.tipo]}>{ROTULO[p.tipo]}</Selo>
              </div>
            </div>
          </Cartao>
        )), <Paginacao key="paginas" pagina={pag.pagina} total={q.data.itens.length} aoMudar={pag.aoMudar} rotulo="Páginas dos pagamentos" />, antigos && <div key="antigos">{antigos}</div>]
      )}
    </Pilha>
  );
}
